import Vue from 'vue'
import VueSticky from 'vue-sticky'
Vue.directive('sticky', VueSticky)
